export default __webpack_public_path__ + "static/media/lodgify_step12.26c76601.jpg";